/**
 * Alle href mit email-bookmarks demaskieren
  */
$(function() {
    $('a[href*="hxemail"]').each(function (index,element) {
        url = hx.replace(element.getAttribute('href'),"hxemail-","");
        url = 'mailto:'+hx.replace(url,"-","@");
        element.setAttribute('href',url);
    });
});
